<template>
  <div id="News">
    <a-list item-layout="horizontal" :data-source="newsList" id="news-list">
      <a-list-item slot="renderItem" slot-scope="item, index">
        <router-link
          :to="{ name: 'NewView', params: { id: item.id } }"
          :class="`news-list-` + index"
        >
          <div class="left">
            <div>
              <p class="top title single-line-ellipsis">
                {{ item.title }}
              </p>
              <p class="bottom time">
                <!-- <span>HM pool</span> -->
                <!-- <span class="single-line-ellipsis"> 2020-10-10 17:49:17 </span> -->
              </p>
            </div>
          </div>
          <div class="right">
            <img src="" alt="" />
          </div>
        </router-link>
      </a-list-item>
      <!-- <a-pagination
        size="small"
        :default-current="1"
        :show-size-changer="true"
        :show-quick-jumper="true"
        :total="pagination.total"
        :show-total="(total) => `共 ${total} 条`"
      /> -->
    </a-list>
  </div>
</template>

<script>
import Vue from "vue";
import { List, Pagination } from "ant-design-vue";
Vue.use(List);
Vue.use(Pagination);

export default {
  name: "News",
  props: {},
  beforeCreate() {
    // console.log(
    //   this.$route.path,
    //   "\n" + new Date().valueOf() + " beforeCreate: \n"
    // );
    this.getNotices = () => {
      // 获取公告列表
      this.$axios.get("notices").then((res) => {
        if (res.code === 0) {
          // console.log(res.data);
          this.newsList = res.data;
        } else {
          console.log(res.code, res.message);
          this.$message.warning(res.message);
        }
      });
    };
    this.getNotices();
  },
  data() {
    return {
      newsList: [],
      pagination: {
        total: 500,
      },
    };
  },
  mounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
#News {
  #news-list {
    .ant-list-item {
      border-bottom-color: #616cb1;
    }

    a {
      //: 0.3rem;
      padding: 0.5em 1em;
      border-radius: 0.2rem;
      box-shadow: 0px 0px 18px 0px rgba(0, 0, 0, 0.3);
      background-image: linear-gradient(135deg, #626db2, #3b4276);
      display: flex;
      justify-content: space-between;
      flex-wrap: nowrap;
      align-content: center;
      align-items: center;
      width: 100%;

      > .left {
        flex: 0 1 100%;
        position: relative;
        //: 0.3rem;
        height: 3em;
        line-height: 1.5em;

        > * {
          height: 3em;
          line-height: 1.5em;
          width: 100%;
          position: absolute;
          padding-right: 1em;

          > p.bottom.time {
            //: 0.8em;
            color: #dcdcdc;
          }
        }
      }

      > .right {
        flex: 0 0 2rem;
      }
    }
  }
}
</style>
